import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table, Switch, Spin, Popover, Popconfirm, message } from "antd";
import { isReadOnly } from "../../utils/permission";
import { connect } from "react-redux";
import { resetPassword } from "../../redux/actions/user";

class ViewUserAdminTable extends Component {
  state = {
    visible: {}
  };

  edit = id => {
    const { history, match } = this.props;
    history.push("/airline/viewuser/editadmin/" + match.params.id + "/" + id);
  };

  onDelete = item => {
    let { visible } = this.state;
    visible[item.key] = false;
    this.setState({ visible });
    this.props.onDelete(item);
  };

  confirmReset = item => {
    const body = { inUserId: item.userId };
    this.props.resetPassword(body).then(res => {
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        message.success("Reset passord for " + item.email + " success");
      }
    });
  };

  visibleChange = item => {
    let { visible } = this.state;
    visible[item.key] = false;
    this.setState({ visible });
  };

  render() {
    const { isLoading, data } = this.props;
    const readOnly = isReadOnly("airline");
    const dataTable =
      data &&
      data.response &&
      data.response
        .filter(x => x.isAdmin === 1)
        .map((d, i) => ({
          key: i,
          no: i + 1,
          fullName: d.fullName,
          userId: d.userId,
          email: d.email,
          lastLogin: d.lastLogin,
          status: d.isEnable === 1
        }));
    let columns = [
      {
        title: "#",
        dataIndex: "no",
        key: "no",
        width: 50
      },
      {
        title: "Name",
        dataIndex: "fullName",
        key: "fullName",
        align: "left",
        width: 200
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        align: "left",
        width: 200
      },
      {
        title: "Last login",
        dataIndex: "lastLogin",
        key: "lastLogin",
        width: 150
      },
      {
        title: "Status",
        key: "status",
        width: 100,
        render: item =>
          !readOnly && (
            <Switch
              disabled={readOnly}
              onChange={checked => this.props.onCheckChange(item, checked)}
              checked={item.status}
            />
          )
      },
      !readOnly && {
        title: "Reset Password",
        key: "reset",
        width: 120,
        render: item =>
          readOnly || item.typeUser === 2 ? (
            <button
              disabled
              type="button"
              className="btn btn-outline-danger btn-sm"
            >
              <FontAwesomeIcon icon="retweet" />
            </button>
          ) : (
            <Popconfirm
              title="Are you sure ?"
              onConfirm={() => this.confirmReset(item)}
              okText="Confirm"
              cancelText="Cancel"
            >
              <button
                disabled={readOnly}
                type="button"
                className="btn btn-outline-danger btn-sm"
              >
                <FontAwesomeIcon icon="retweet" />
              </button>
            </Popconfirm>
          )
      },
      {
        title: "Edit",
        key: "edit",
        width: 80,
        render: item =>
          !readOnly && (
            <button
              onClick={() => this.edit(item.userId)}
              type="button"
              className="btn btn-outline-warning btn-sm"
            >
              <FontAwesomeIcon icon="pen" />
            </button>
          )
      },
      {
        title: "Delete",
        key: "delete",
        width: 80,
        render: item =>
          readOnly ? (
            <button
              disabled
              type="button"
              className="btn btn-outline-danger btn-sm"
            >
              <FontAwesomeIcon icon="trash" />
            </button>
          ) : (
            <Popover
              visible={this.state.visible[item.key]}
              onVisibleChange={_visible => {
                let { visible } = this.state;
                visible[item.key] = _visible;
                this.setState({ visible });
              }}
              content={
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm mr-2"
                    onClick={() => this.onDelete(item)}
                  >
                    Delete
                  </button>

                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => this.visibleChange(item)}
                  >
                    Cancel
                  </button>
                </div>
              }
              title="Are you sure?"
              trigger="click"
            >
              <button
                disabled={readOnly}
                type="button"
                className="btn btn-outline-danger btn-sm"
              >
                <FontAwesomeIcon icon="trash" />
              </button>
            </Popover>
          )
      }
    ];

    columns.forEach(x => {
      x.onHeaderCell = () => ({
        className: "ant-table-column-has-actions ant-table-column-has-sorters"
      });
      x.sorter = (a, b) => {
        try {
          if (typeof a[x.dataIndex] === "number")
            return a[x.dataIndex] - b[x.dataIndex];
          return a[x.dataIndex].localeCompare(b[x.dataIndex]);
        } catch (e) {}
      };
    });

    const table = (
      <Table
        footer={
          isLoading
            ? () => (
                <div className="text-center">
                  <Spin className="pr-2" />
                  loading...
                </div>
              )
            : null
        }
        className="tbody-center bg-white"
        columns={columns}
        pagination={false}
        dataSource={dataTable}
      />
    );

    return <div className="card card-body card-header-table">{table}</div>;
  }
}

const mapStateToProps = state => ({
  language: state.language
});

const mapDispatchToProps = dispatch => ({
  resetPassword: body => dispatch(resetPassword(body))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewUserAdminTable);
